import React from "react";
import "./App.scss";
import NavToggle from "./Components/NavToggle";
import HomePage from "./Pages/HomePage";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link
} from "react-router-dom";
import AboutPage from "./Pages/AboutPage";
import SkillsPage from "./Pages/SkillsPage";
import ProjectsPage from "./Pages/ProjectsPage";
import ContactPage from "./Pages/ContactPage";
import Provider from "./Translation/Provider";
import { AppContextProvider } from "./Translation/Context";
import Footer from "./Components/Footer";

export default function App() {
  return (
    <AppContextProvider>
      <Provider>
        <div className="App">
          <NavToggle />
          <div className="main-content">
            <div className="content">
              <Switch>
                <Route path="/" exact>
                  <HomePage />
                </Route>
                <Route path="/about" exact>
                  <AboutPage />
                </Route>
                <Route path="/skills" exact>
                  <SkillsPage />
                </Route>
                <Route path="/projects" exact>
                  <ProjectsPage />
                </Route>
                <Route path="/contact" exact>
                  <ContactPage />
                </Route>
              </Switch>
              <Footer />
            </div>
          </div>
        </div>
      </Provider>
    </AppContextProvider>
  );
}
